// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUnmatchedPushTotalBalanceDto
 */
export interface IUnmatchedPushTotalBalanceDto {
    /**
     * 
     * @type {number}
     * @memberof IUnmatchedPushTotalBalanceDto
     */
    total_balance?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IUnmatchedPushTotalBalanceDto
     */
    organization_names?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IUnmatchedPushTotalBalanceDto
     */
    matched_organizations_count?: number;
}

/**
 * Check if a given object implements the IUnmatchedPushTotalBalanceDto interface.
 */
export function instanceOfIUnmatchedPushTotalBalanceDto(value: object): value is IUnmatchedPushTotalBalanceDto {
    return true;
}

export function IUnmatchedPushTotalBalanceDtoFromJSON(json: any): IUnmatchedPushTotalBalanceDto {
    return IUnmatchedPushTotalBalanceDtoFromJSONTyped(json, false);
}

export function IUnmatchedPushTotalBalanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUnmatchedPushTotalBalanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_balance': json['total_balance'] == null ? undefined : json['total_balance'],
        'organization_names': json['organization_names'] == null ? undefined : json['organization_names'],
        'matched_organizations_count': json['matched_organizations_count'] == null ? undefined : json['matched_organizations_count'],
    };
}

export function IUnmatchedPushTotalBalanceDtoToJSON(json: any): IUnmatchedPushTotalBalanceDto {
    return IUnmatchedPushTotalBalanceDtoToJSONTyped(json, false);
}

export function IUnmatchedPushTotalBalanceDtoToJSONTyped(value?: IUnmatchedPushTotalBalanceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_balance': value['total_balance'],
        'organization_names': value['organization_names'],
        'matched_organizations_count': value['matched_organizations_count'],
    };
}

